const state = ({
  searchText: "",
  supportDetails: "",
  clickedQuestion: []
})

const getters = {
  getSearchText: state => state.searchText,
  getSupportDetails: state => state.supportDetails,
  getClickedQuestion: state => state.clickedQuestion
}

const actions = {
  searchText ({ commit }, payload) {
    commit('searchText', payload)
  },
  supportDetails ({ commit }, payload) {
    commit('supportDetails', payload)
    commit('clickedQuestion', payload.id)
  },
}

const mutations = {
  searchText (state, payload) {
    state.searchText = payload
  },
  supportDetails (state, payload) {
    state.supportDetails = payload
  },
  clickedQuestion(state, payload) {
    state.clickedQuestion = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}